
<template>
  <div class="footer">
    <p style="text-align: center;">备案号:<a href="https://beian.miit.gov.cn/">{{ icp }}</a></p>
  </div>
</template>
<script>
export default {
  props: ['icp'],
  setup() {

    return {

    }
  }
}
</script>
<style scoped>

</style>